<app-base-modal
  [title]="'Типичный дефект'"
>
  <mat-tab-group (selectedTabChange)="handleTabChange($event)">
    <mat-tab label="Создать">
      <div class="fields">
        <mat-form-field
          appearance="outline"
          class="field"
        >
          <mat-label>Элемент товара</mat-label>
          <mat-select
            [value]="selectedDefect"
            (selectionChange)="getDefectValues($event)"
          >
            @for (option of productCardDefectValueDialogData.defects; track option.id) {
              <mat-option [value]="option.id">
                {{option.title}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field
          class="field"
          appearance="outline"
        >
          <mat-label>Название</mat-label>
          <input
            matInput
            placeholder="Введите название"
            [(ngModel)]="name"
            [disabled]="!selectedDefect"
          >
        </mat-form-field>
      </div>
    </mat-tab>
    <mat-tab label="Изменить">
      <div class="fields">
        <mat-form-field
          appearance="outline"
          class="field"
        >
          <mat-label>Элемент товара</mat-label>
          <mat-select
            [value]="selectedDefect"
            (selectionChange)="getDefectValues($event)"
          >
            @for (option of productCardDefectValueDialogData.defects; track option.id) {
              <mat-option [value]="option.id">
                {{option.title}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="field"
        >
          <mat-label>Типичный дефект</mat-label>
          <mat-select
            [disabled]="!selectedDefect"
            [(ngModel)]="selectedDefectValue"
          >
            @for (option of defectValues; track option.id) {
              <mat-option [value]="option.id">
                {{option.value}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field
          class="field"
          appearance="outline"
        >
          <mat-label>Название</mat-label>
          <input
            matInput
            placeholder="Введите название"
            [(ngModel)]="name"
            [disabled]="!selectedDefectValue"
          >
        </mat-form-field>
      </div>
    </mat-tab>
    <mat-tab label="Удалить">
      <div class="fields">
        <mat-form-field
          appearance="outline"
          class="field"
        >
          <mat-label>Элемент товара</mat-label>
          <mat-select
            [value]="selectedDefect"
            (selectionChange)="getDefectValues($event)"
          >
            @for (option of productCardDefectValueDialogData.defects; track option.id) {
              <mat-option [value]="option.id">
                {{option.title}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="field"
        >
          <mat-label>Типичный дефект</mat-label>
          <mat-select
            [disabled]="!selectedDefect"
            [(ngModel)]="selectedDefectValue"
          >
            @for (option of defectValues; track option.id) {
              <mat-option [value]="option.id">
                {{option.value}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </mat-tab>
  </mat-tab-group>
  <div class="buttons-container">
    <button
      mat-button
      class="save-button"
      color="primary"
      [disabled]="isDisabledBtn()"
      (click)="handleBtn()"
    >
      {{ getBtnText() }}
    </button>
    <button
      mat-button
      tabindex="-1"
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>

